import httpService from '../../../helpers/http.service'

export default {

    counter() {
        return httpService.post(`counters`);
    }
}
